<template>
  <vx-card class="mt-base">
    <h4 class="mb-5">
      <strong>2. Structure</strong> is about the thickness of each individual strand of hair. This
      can be classified as fine, medium, or coarse (also called thick). Structure is essential as it
      can affect how the hair holds specific styles or responds to certain products.
    </h4>

    <centered-image-wrapper
      :image="require('@/assets/images/experiences/hairdressing/activity_21.png')"
      classes="xl:w-1/2 lg:w-2/3 w-full"
      alt="Three circles of vertical lines showing hair structure: fine strands are thin, medium strands are thicker, and coarse strands are the thickest."
    />

    <h4 class="mb-5">Take the Structure Test: Is My Hair Fine, Medium, or Coarse?</h4>
    <p class="mb-5">
      To assess which category your hair falls into, pluck a single strand from your head and lay it
      flat on a table or other flat surface.
    </p>
    <p class="mb-5">
      Then, cut a length of sewing thread about 15cm long and place it next to your strand of hair
      on the table for comparison.
    </p>

    <ul class="default-list">
      <li>If your hair is thinner than the length of a thread, then your hair is fine.</li>
      <li>If your hair is the same thickness as the thread, then your hair is medium.</li>
      <li>If your hair is thicker than the length of the thread, then your hair is coarse.</li>
    </ul>

    <div v-for="(question, index) in questions" :key="index">
      <h5 class="mb-5 questionlabel">{{ question.question }}</h5>
      <div class="vx-row my-5">
        <div class="vx-col w-full mb-2" v-if="isEditable">
          <select
            class="default-select"
            v-model="answers['question' + index]"
            :aria-label="question.question"
          >
            <option v-for="answer in question.answers" :key="answer.val" :value="answer.val">
              {{ answer.answer }}
            </option>
          </select>
        </div>
        <div class="my-2 mx-5" v-else>
          <p
            class="my-2"
            v-for="answer in question.answers"
            :key="answer.val"
            v-if="answers['question' + index] != 0"
          >
            <span v-if="answers['question' + index] == answer.val">{{ answer.answer }}</span>
          </p>
          <p class="my-2" v-else>N/A</p>
        </div>
      </div>
    </div>

    <h4 class="mb-5">Structure: What Does This Mean for Hair Treatment?</h4>

    <p class="mb-5"><strong>For fine hair:</strong></p>

    <ul class="default-list">
      <li>Use volumising shampoo and conditioner.</li>
      <li>Use conditioner on ends of hair only - not scalp!</li>
      <li>Avoid growing hair too long.</li>
      <li>Air-dry hair to avoid heat damage.</li>
      <li>When applying heat, use lower temperatures.</li>
    </ul>
    <p class="mb-5"><strong>For coarse hair:</strong></p>
    <ul class="default-list">
      <li>Use a detangling hairbrush with short, flexible bristles.</li>
      <li>Use hydration products for frizzy hair.</li>
      <li>Brush hair in small sections.</li>
      <li>Layers can add movement to heavy hair.</li>
    </ul>

    <save-buttons
      :is-editable="isEditable"
      @save="save"
      :student-back="
        '/student/work-experience/' + this.$route.params.id + '/activities/identifying-hair-types'
      "
      :teacher-back="
        '/teacher/vje/experience/view/' +
        this.$route.params.id +
        '/activities/identifying-hair-types'
      "
    />
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      questions: {
        1: {
          question: 'My hair structure is:',
          answers: [
            { val: 0, answer: 'Select your hair structure' },
            { val: 1, answer: 'Fine' },
            { val: 2, answer: 'Medium' },
            { val: 3, answer: 'Course' },
          ],
        },
      },
      answers: {
        question1: 0,
      },
    };
  },
  methods: {
    save() {
      this.data = this.answers;
      this.saveActivity(this.$route.params.slug, this.data, -1);
    },
  },
  computed: computed,
  inject: inject,
  mounted() {
    if (this.data.question1) {
      this.answers = this.data;
    }
  },
};
</script>
